var map = {
	"./de.json": [
		1725,
		41
	],
	"./en-AU.json": [
		1726,
		42
	],
	"./en-GB.json": [
		1727,
		43
	],
	"./en-HK.json": [
		1728,
		44
	],
	"./en-SG.json": [
		1729,
		45
	],
	"./en-us.json": [
		1730,
		46
	],
	"./fr.json": [
		1731,
		47
	],
	"./global.json": [
		1732,
		48
	],
	"./it.json": [
		1733,
		49
	],
	"./zh-Hant.json": [
		1734,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1722;
module.exports = webpackAsyncContext;